module.exports = __webpack_public_path__ + "media/vo-splash-screen.2f563a44.mp3";